import React from 'react';

import './styles/header.css'



class App extends React.Component {

    constructor(props){
      super(props);
    }

    componentDidMount() {
    }

  render() {
    return (

        <div align="center">
            <h1>Carpe Monte Carlo Scheduler Tool</h1>
            <h1>Pages under construction :(</h1>
        </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js